import { lazy } from 'react';

export const SignUpLiquid = lazy(() => import('./SignUpLiquid.component'));
